import { useBottomFloatingLog } from '../log/useBottomFloatingLog';

export const useScrollService = () => {
  const { clickScrollUBL } = useBottomFloatingLog();

  const handleScroll = (direction: 'top' | 'bottom') => {
    if (typeof window !== 'undefined') {
      window.scrollTo({
        top: direction === 'top' ? 0 : document.body.scrollHeight,
        behavior: 'smooth',
      });
    }
    clickScrollUBL(direction);
  };

  return { handleScroll };
};
